import { ClassBaseService } from './../../services/class-base.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonService } from 'app/services/common.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { NotificationService } from './../../services/notification.service';
import { Component, EventEmitter, Inject, OnDestroy, Output, Renderer2 } from '@angular/core';
import { MessageGridComponent } from '../message-grid/message-grid.component';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_CONFIG } from '../../app.config';
import { DraggableModalService } from '../shared/draggable-modal/draggable-modal.service';
import { IAppConfig } from '../../app.config.shared';
import { ConfirmModalService } from '../shared/confirm-modal/confirm-modal.service';

@Component({
  selector: 'app-message-list',
  templateUrl: './message-list.component.html',
  styleUrls: ['./message-list.component.scss']
})
export class MessageListComponent extends MessageGridComponent implements OnDestroy{
  @Output() showMessageModal = new EventEmitter();
  constructor(
    notificationService: NotificationService,
    _commonAuthService: CommonAuthenticationService,
    @Inject(APP_CONFIG) config: IAppConfig,
    _commonService: CommonService,
    _commonRequestResponseService: CommonRequestResponseService,
    commonDataSharedService: CommonDataSharedService,
    _router: Router,
    _routes: ActivatedRoute,
    draggableModalService: DraggableModalService,
    private renderer: Renderer2,
    confirmModalService: ConfirmModalService
  ) {
    super(notificationService, _commonAuthService, config, _commonService, _commonRequestResponseService, commonDataSharedService, _router, _routes, draggableModalService, confirmModalService);
  }

  showNewMessage() {
    this.isEdit = false;
    this.hidden = false;
    const currentUrl = window.location.href.split('/');
    this.messageData = {};
    this.messageData.queueData = [];
    this.messageData.messageFromScreen = currentUrl;
    this.messageData.messageAssignmentType = 0;
    this.messageData.messageAssignmentSubType = 0;
    const resetJson = { hidden: this.hidden, isEdit: this.isEdit, messageData: this.messageData };
    this.showMessageModal.emit(resetJson);
  }

  toggleMessage(message: any) {
    message.opened = !message.opened;
    if (message.opened) {
      this.renderer.addClass(document.body, 'mobile-message-opened');
      return;
    }
    this.expandedItem = {};
    this.renderer.removeClass(document.body, 'mobile-message-opened');
  }

  trackByFn(i, item) {
    return item.messageId
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.renderer.removeClass(document.body, 'mobile-message-opened');
  }
}
